import { useState } from "react"
import { Link } from "@remix-run/react"
import { ChevronRight } from "~/components/icons"
import type { ResultType } from "~/types/search"

type ExploreSectionHeaderProps = {
  title: string
  navigateTo: string | ((resultType: ResultType) => void)
  navigateToLabel?: string
  resultType?: ResultType
}

export function ExploreSectionHeader({ title, navigateTo, navigateToLabel = "Explore All", resultType }: ExploreSectionHeaderProps) {
  const [isHovered, setIsHovered] = useState(true)

  const commonProps = {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    className: "group relative inline-flex items-end hover:text-zinc-600 transition-colors ease-in-out duration-300",
  }

  const textClasses = `overflow-hidden transition-none md:transition-all md:duration-500 md:ease-in-out ${
    isHovered ? "opacity-100 w-auto translate-x-0 pl-3" : "opacity-0 w-0 -translate-x-4"
  }`
  const iconClasses = `text-primary self-center transition-none md:transition-all md:duration-300 ${
    isHovered ? "w-6 h-6 translate-y-[2px]" : "w-8 h-8 -translate-x-1 translate-y-[1px]"
  }`

  return (
    <h4 className="px-1 antialiased tracking-wide text-md md:text-xl font-bold">
      {typeof navigateTo === "function" ?
        <button {...commonProps} onClick={() => navigateTo(resultType!)}>
          <span>{title}</span>
          <div className="flex items-end absolute left-full top-1/2 -translate-y-1/2">
            <span className={textClasses}>
              <span className="text-sm text-primary font-bold whitespace-nowrap">View All Results</span>
            </span>
            <ChevronRight fill="currentColor" className={iconClasses} />
          </div>
        </button>
      : <Link
          to={navigateTo}
          className="group relative inline-flex items-end hover:text-zinc-600 transition-none md:transition-colors md:ease-in-out md:duration-300">
          <span>{title}</span>
          <div className="flex items-end absolute left-full top-1/2 -translate-y-1/2">
            <span className="w-0 overflow-hidden opacity-0 -translate-x-4 md:group-hover:opacity-100 md:group-hover:w-auto md:group-hover:translate-x-0 md:group-hover:pl-3 transition-none md:transition-all md:duration-500 md:ease-in-out">
              <span className="text-sm text-primary font-bold whitespace-nowrap">{navigateToLabel}</span>
            </span>
            <ChevronRight
              fill="currentColor"
              className="text-primary self-center -translate-x-1 translate-y-[1px] w-8 h-8 md:group-hover:w-6 md:group-hover:h-6 md:group-hover:translate-y-[2px] transition-none md:transition-all md:duration-300"
            />
          </div>
        </Link>
      }
    </h4>
  )
}

export function getCollectionLink(collection: { Title: string; href?: string }) {
  if (collection.href) return collection.href
  if (collection.Title === "MakeLatestVideosLoveNotPorn") return "/videos/latest"
  return `/videos/category/${collection.Title}`
}

export function getNavigateToLabel(collection: { Title: string }) {
  if (collection.Title === "Your Happy Place: For You") return "Visit Your Happy Place"
  return "Explore All"
}
